/* eslint-disable check-file/filename-naming-convention */
export const handleScrollToRef = (
  ref: React.RefObject<HTMLElement | null>,
  isStickyFooter?: boolean
) => {
  if (isStickyFooter) {
    setTimeout(() => {
      const element = document.getElementById("question-details-section-id");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  } else {
    setTimeout(() => {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 100);
  }
};

export const handleScrollToRefAnyoneVisiting = (
  ref: React.RefObject<HTMLElement | null>,
  isStickyFooter?: boolean
) => {
  if (isStickyFooter) {
    setTimeout(() => {
      const element = document.getElementById("question-details-section-id");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }, 150);
  } else {
    setTimeout(() => {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 150);
  }
};

export const smoothScrollTopScreen = () => {
  if (typeof window !== "undefined") {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }
};

export const handleFocusScrollContactForm = (
  inputName: "emailValue" | "phoneValue",
  ref: React.RefObject<HTMLElement | null>
) => {
  if (inputName === "emailValue" && ref.current) {
    setTimeout(() => {
      const element = document.getElementById("main-header-id");
      if (element) {
        const yOffset = -10;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
  }
  if (inputName === "phoneValue" && ref.current) {
    setTimeout(() => {
      const element = document.getElementById("main-header-id");
      if (element) {
        const yOffset = 50;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
  }
};

//

export function smoothScrollToRef(
  ref: React.RefObject<HTMLElement | null>,
  delay: number = 150
) {
  setTimeout(() => {
    ref.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }, delay);
}

export const organiserMedscrollToAnswer = (
  isStickyFooter: boolean,
  type?: string
) => {
  setTimeout(() => {
    const targetId = isStickyFooter
      ? `${type}-main-cta-button-id`
      : "question-details-section-id";

    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: isStickyFooter ? "end" : "start",
      });
    }
  }, 200);
};

export const organiserMedscrollToAnswerWithFooter = (
  isStickyFooter: boolean,
  type?: string
) => {
  setTimeout(() => {
    const targetId = isStickyFooter
      ? `${type}-main-cta-button-id`
      : "question-details-section-id";

    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: isStickyFooter ? "end" : "center",
      });
    }
  }, 200);
};

export const scrollToTop = (smooth: boolean = true) => {
  if (typeof window !== "undefined") {
    window.scrollTo({
      top: 0,
      behavior: smooth ? "smooth" : "auto",
    });
  }
};
